<template>
  <div class="text">
    <h1>Impressum</h1>

    <h2>Angaben gem&auml;&szlig; &sect; 5 TMG</h2>
    <p>
      Mark Wetter<br />
      R&ouml;hrborngasse 54<br />
      60388 Frankfurt am Main
    </p>

    <h2>Kontakt</h2>
    <p>
      Telefon: 0151-43121118<br />
      E-Mail: mail@poe.watch
    </p>

    <p>Quelle: <a href="https://www.e-recht24.de">e-recht24.de</a></p>
  </div>
</template>

<script>
export default {};
</script>
<style>
.text {
  color: white;
}
</style>
